module.exports = __webpack_public_path__ + "img/aereo.9ec90b00.svg";